import React from 'react';
// Svgs
import artemLogo from './../../assets/svgs/artem-logo-white.svg';
import artemSmallLogo from './../../assets/icons/artem-small-icon-new.svg';
import artemColorLogo from './../../assets/svgs/artem-color-icons.png';

const SVGS = {
  'artem-logo-white': artemLogo,
  'artem-small-icon-new': artemSmallLogo,
  'artem-color-icons': artemColorLogo,
};

/**
 * Return the matching SVG as a React Component.
 * Results in an inlined SVG Element. If there's no match,
 * return `null`
 */
export default function getSvg(key, props) {
  if (!key || !SVGS[key]) {
    return React.createElement('div', null, 'Missing SVG');
  }

  return React.createElement(SVGS[key], props);
}

export { SVGS };
